<template>
  <div
    class="Fuell-Transactions--review-info-bar"
    v-if="!isCallingTransactionDashboardWithoutFilters"
  >
    <div
      v-show="transactionsNotCompleted > 0"
      :class="{'active': isActive('IS_COMPLETED') && !filtersAmount}"
      class="info-block clickable"
      @click="setFilters('IS_COMPLETED')"
    >
      <div class="info-block--info-item">
        <span class="info-item--count">
          {{ transactionsNotCompleted }}
        </span>
        <i18n
          path="transactions_dashboard_total_missing_info_text"
          class="Fuell-Text"
        >
        </i18n>
        <inline-svg
          class="active-info ml-1"
          :src="require('@/assets/img/icons/icon-info-base.svg')"
        />
      </div>
    </div>
    <template v-if="!expenses">
      <div
        v-show="transactionsNotReviewed > 0"
        :class="{'active': isActive('NOT_REVIEWED') && !filtersAmount}"
        class="info-block clickable"
        @click="setFilters('NOT_REVIEWED')"
      >
        <div class="info-block--info-item">
          <span class="info-item--count">
            {{ transactionsNotReviewed }}
          </span>
          <i18n
            path="transactions_dashboard_total_not_reviewed_text"
            class="Fuell-Text"
          >
          </i18n>
          <inline-svg
            class="ml-1"
            :src="require('@/assets/img/icons/icon-info-base.svg')"
          />
        </div>
      </div>
    </template>

  </div>
  <div
    class="Fuell-Transactions--review-info-bar"
    v-else-if="isCallingTransactionDashboardWithoutFilters"
  >
    <spinner
      :spinnerClassList="'icon--24 text-primary'"
      :spinnerContainerClass="'p-0 mx-5'"
    />
  </div>
</template>

<script>
import { REVIEW_STATUS } from '@/constants/reviewStatus'
import Spinner from '@/components/Commons/Spinner'
import InlineSvg from 'vue-inline-svg'

export default {
  name: 'TransactionsReviewInfoBar',
  components: { Spinner, InlineSvg },
  props: {
    expenses: {
      type: Boolean,
      default: false
    },
    defaultFilters: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      filterName: ''
    }
  },
  computed: {
    transactionsWithoutFiltersDashboard () {
      return this.$store.getters['TransactionsStore/transactionsWithoutFiltersDashboard']
    },
    transactionsNotCompleted () {
      return this.transactionsWithoutFiltersDashboard && this.transactionsWithoutFiltersDashboard.notCompleted ? this.transactionsWithoutFiltersDashboard.notCompleted : 0
    },
    transactionsNotReviewed () {
      return this.transactionsWithoutFiltersDashboard && this.transactionsWithoutFiltersDashboard.notReviewed ? this.transactionsWithoutFiltersDashboard.notReviewed : 0
    },
    isCallingTransactionDashboardWithoutFilters () {
      return this.$store.getters['TransactionsStore/isCallingTransactionDashboardWithoutFilters']
    },
    filtersAmount () {
      return this.$store.getters['TransactionsStore/userSelectedFiltersAmount']
    }
  },
  methods: {
    async setFilters (filterName) {
      this.$emit('resetFilters')
      if (this.isActive(filterName)) {
        this.filterName = undefined
      } else {
        this.filterName = filterName
      }
      const filters = { ...this.defaultFilters }

      if (filterName === 'IS_COMPLETED') {
        filters['isCompleted'] = false
        filters['reviewStatus.code'] = [REVIEW_STATUS.AWAITING_REVIEW, REVIEW_STATUS.OFFICE_FLOW_REVISION]
        filters['iCanReview'] = true
      }

      if (filterName === 'NOT_REVIEWED') {
        filters['isCompleted'] = true
        filters['reviewStatus.code'] = [REVIEW_STATUS.AWAITING_REVIEW, REVIEW_STATUS.OFFICE_FLOW_REVISION]
        filters['iCanReview'] = true
      }

      if (this.$route.name === 'my_charged_transactions' || this.$route.name === 'my_authorizations_transactions' || this.$route.name === 'my_declined_transactions' || this.$route.name === 'my_pending_reimbursements' || this.$route.name === 'my_history_reimbursements') {
        delete filters['iCanReview']
      }

      this.$store.dispatch('TransactionsStore/toggleSelectAll', false)
      this.$store.dispatch('TransactionsStore/resetCurrentFilteredView')
      await this.$store.dispatch('TransactionsStore/fetchTransactionsWithoutFilters', filters)
      await this.$store.dispatch('TransactionsStore/fetchTransactionDashboard', filters)
    },
    close () {
      this.$emit('close')
    },
    isActive (filterName) {
      return (this.filterName === filterName)
    }
  },
  mounted () {
    this.$root.$on('resetReviewBar', () => {
      this.filterName = ''
    })
  }
}
</script>

<style lang="scss" scoped>
.Fuell-Transactions--review-info-bar {
  display: flex;
  min-width: fit-content;
}

.info-block {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 8px;
  border-radius: 16px;
  gap: 4px;
  background-color: var(--grey-action-3-active);
  margin-right: 5px;
  max-height: 24px;
  max-width: max-content;

  &--info-item {
    display: flex;
    flex-direction: row;
    align-items: center;

    & > * {
      margin: 0px 5px;
    }
  }

  .info-block--close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 2px;

    &:hover {
      background-color: var(--grey-action-3-hover);
    }

    &-img {
      width: 8px;
      height: 8px;
    }
  }
}

.info-block.active {
  background-color: var(--semantic-brand-tint);

  & > .info-block--info-item {
    > .Fuell-Text,
    .info-item--count {
      color: var(--semantic-brand-main);
    }

    svg {
      filter: invert(38%) sepia(62%) saturate(3783%) hue-rotate(186deg)
        brightness(100%) contrast(103%);
    }
  }
}

.info-block--info-item .Fuell-Text {
  font-size: 13px;
  line-height: 23px;
  @media screen and (max-width: 576px) {
    // font-size:12px;
  }
}

.info-item--count {
  font-size: 13px;
  font-weight: 500;
  line-height: 23px;
  color: var(--text-body);
}

.info-item--blue-text {
  margin-left: 24px;
  color: var(--blue-action-1-active);
}
</style>
